export const enum TruncatedStatus {
  Unknown = `unknown`,
  None = `none`,
  Expanded = `expanded`,
  Collapsed = `collapsed`,
}

export type ClampedTextAttrs = {
  text: string;
  lines?: number;
};

export type ClampedTextState = {
  status: TruncatedStatus;
};
